(() => {
  angular
    .module('app')
    .controller('common.views.aceClaims.registerClaimsModal', RegisterClaimsModalController);

  RegisterClaimsModalController.$inject = [
    '$uibModalInstance',
    'abp.services.app.aceClaims',
    'Hms.Ace.Dto.RegisterClaimOutcome',
    'registerState',
  ];

  function RegisterClaimsModalController(
    $uibModalInstance,
    aceClaimsSvc,
    enumRegisterClaimOutcome,
    registerState
  ) {
    const vm = this;

    // The server owns normalisation (AceClaimsAppService.ParseClaimNumbers): it splits on commas,
    // semicolons and whitespace, trims, drops empties and dedupes case-insensitively. This mirrors
    // that rule so the detected count agrees with the feedback rows — display only, never
    // authoritative. The raw text is what gets submitted.
    // Exactly ClaimNumberSeparators, not \s — \s would also split on non-breaking spaces the
    // server keeps, so a paste out of Word would count higher here than the server parses.
    const claimNumberSeparators = /[,; \t\r\n]+/;

    // The whole batch rides one ACE call on a 100-second default timeout, so an oversized paste
    // fails wholesale and looks to the operator like ACE rejecting their claims.
    const maxClaimNumbers = 100;

    vm.loading = 0;
    vm.claimNumbersText = '';
    vm.countText = '';
    vm.detectedCount = 0;
    vm.exceededMax = false;
    vm.hasSubmitted = false;
    vm.results = [];

    vm.onClaimNumbersChanged = onClaimNumbersChanged;
    vm.register = register;
    vm.close = close;

    function onClaimNumbersChanged() {
      const parsed = parseClaimNumbers(vm.claimNumbersText);

      vm.detectedCount = parsed.numbers.length;
      vm.exceededMax = vm.detectedCount > maxClaimNumbers;

      if (vm.exceededMax) {
        vm.countText = App.localize(
          'AceRegisterClaimsMaxExceeded',
          vm.detectedCount,
          maxClaimNumbers
        );
      } else if (parsed.duplicateCount) {
        vm.countText = App.localize(
          'AceClaimNumbersDetectedDeduped',
          vm.detectedCount,
          parsed.duplicateCount
        );
      } else {
        vm.countText = App.localize('AceClaimNumbersDetected', vm.detectedCount);
      }
    }

    function parseClaimNumbers(text) {
      const tokens = (text || '')
        .split(claimNumberSeparators)
        .filter((token) => token.length > 0);

      const seen = new Set();
      const numbers = [];
      tokens.forEach((token) => {
        const key = token.toLowerCase();
        if (!seen.has(key)) {
          seen.add(key);
          numbers.push(token);
        }
      });

      return { numbers, duplicateCount: tokens.length - numbers.length };
    }

    function register() {
      if (!vm.detectedCount || vm.exceededMax) return;

      vm.loading += 1;
      aceClaimsSvc
        .registerClaims({ claimNumbers: vm.claimNumbersText })
        .success((data) => {
          vm.results = (data.results || []).map(toResultDisplay);
          vm.hasSubmitted = true;

          // Registration writes an AceClaims row for every outcome that reached ACE — including
          // per-claim failures — so the grid is stale from here regardless of what came back.
          registerState.shouldRefresh = true;
        })
        .finally(() => {
          vm.loading -= 1;
        });
    }

    function toResultDisplay(result) {
      return {
        claimNumber: result.claimNumber,
        isSuccess: result.outcome === enumRegisterClaimOutcome.Registered.id,
        outcomeText: getOutcomeText(result),
      };
    }

    // Successful registration starts the analysis in the same call, so it reports in the AceStatus
    // vocabulary the grid uses rather than inventing a separate "registered" state. Only the error
    // outcome carries text worth surfacing verbatim — the others are known cases with fixed labels.
    function getOutcomeText(result) {
      switch (result.outcome) {
        case enumRegisterClaimOutcome.Registered.id:
          return App.localize('AceStatusProcessing');
        case enumRegisterClaimOutcome.NotFound.id:
          return App.localize('AceRegisterOutcomeNotFound');
        case enumRegisterClaimOutcome.NotEligible.id:
          return App.localize('AceRegisterOutcomeNotEligible');
        default:
          return result.remarks;
      }
    }

    function close() {
      $uibModalInstance.close();
    }
  }
})();
